import { ClassNameOnlyProps } from 'module/types/common';
import { DateField } from 'module/types/filter-field/field/filterable-field';
import { Component, createRef, ReactNode } from 'react';
import { Popover } from './components';
import { DateFieldValue } from '../../field-editable-value/date';
import type { Moment } from 'moment';

interface Focusable {
  focus: () => void;
}

interface Props<T extends string | number = string> extends ClassNameOnlyProps {
  id?: string;
  field?: DateField<T>;
  title: ReactNode;
  onChange: (latest: T | null) => void;
  disabledDate?: (current: Moment) => boolean;
  value?: string;
  extraFooter?: ReactNode;
  allowClear?: boolean;
  openState?: boolean;
}

export class DateFieldEditorPopover extends Component<Props> {
  innerRef = createRef<Focusable>();

  componentDidMount(): void {
    this.focus();
  }

  focus = () => {
    this.innerRef.current?.focus();
  };

  render() {
    const {
      id = 'date_field_editor_wrapper',
      field,
      title,
      onChange,
      className,
      disabledDate,
      value,
      extraFooter,
      allowClear = true,
      openState = true,
    } = this.props;

    const { innerRef } = this;

    if (!openState) {
      return null;
    }

    return (
      <Popover id={id} className={className}>
        <Popover.Title>{title}</Popover.Title>
        <DateFieldValue
          innerRef={innerRef as any}
          field={field}
          value={value}
          editable
          onChange={(latest?: string) => onChange(latest ?? null)}
          getPopupContainer={() => document.getElementById(id) as HTMLElement}
          disabledDate={disabledDate}
          extraFooter={extraFooter}
          allowClear={allowClear}
        />
      </Popover>
    );
  }
}
